import React, { useState, useEffect, FC, useRef } from "react";
import { Box, Theme, useMediaQuery } from "@mui/material";
import Grid from "@mui/material/Grid2";

interface VideoGalleryProps {
  videoGallery: {
    url: any;
    mediaType: any;
    thumbnail: any;
    type: any;
  };
}

const CustomVideoPlayer: FC<VideoGalleryProps> = ({ videoGallery }) => {
  
  const videoRef = useRef<any>(null);
  const [videoUrl, setVideoUrl] = useState(videoGallery.url);
  useEffect(() => {
    setVideoUrl(videoGallery.url);
  }, [videoGallery.url]);

  useEffect(() => {
    if (videoRef?.current) {
      videoRef?.current.load();
      const attemptPlay = async () => {
        try {
          await videoRef.current.play();
        } catch (err) {
          console.error("Autoplay failed. Awaiting user interaction.", err);
        }
      };

      // Call the async function
      attemptPlay();
    }
  }, [videoUrl]);
  const isSmallScreen = useMediaQuery(
    (theme: Theme) =>
      theme.breakpoints.down("sm") || theme.breakpoints.down("xs")
  );

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: {
                xs: "auto",
                sm: "auto",
                md: "auto",
                lg: "90vh",
                xl: "90vh",
              },
              bgcolor: "black",
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              component="video"
              ref={videoRef}
              poster="https://api.stonehands.in/uploads/video-loader-stone-hands.webp"
              loop
              controls
              autoPlay
              muted
              playsInline
              data-testid="video-player"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: {
                  xs: "cover",
                  sm: "cover",
                  md: "cover",
                  lg: "fill",
                  xl: "fill",
                },
              }}
            >
              <source src={videoUrl} type="video/mp4"/>
              Your browser does not support the video tag.
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CustomVideoPlayer;
